module.exports = __webpack_public_path__ + "media/images/app/special-82be4dc5bfebbd7ff76667bc22ec80a5.svg";